import { ArtHelper, type CartOutputDto, type ShippingRateOutputDto } from "@sticker-giant/sg-frontend-common";

export enum DeliveryMethod {
  SHIP = "Ship",
  PICKUP = "Pickup",
}

export function isDeliveryOptionComplete(cart: CartOutputDto | null | undefined): boolean {
  if (!cart) return false;
  return Boolean(cart.shippingInfo.shippingMethod) || Boolean(cart.shippingInfo.customerPickup);
}

export function isPickupEligible(cart: CartOutputDto | null | undefined): boolean {
  if (!cart) return false;
  if (!cart.shippingInfo?.shippingAddress) return false;

  const isInColorado = cart.shippingInfo.shippingAddress.state === "CO";
  const hasWaterlessTattoo = cart.items.some(item => ArtHelper.isWaterlessTattoo(item.sku.material));

  return isInColorado && !hasWaterlessTattoo;
}

export function isRushAvailable(cart: CartOutputDto | null | undefined, isRushEnabled: boolean): boolean {
  if (!cart) return false;
  return cart.eligibleForExpediting === true && isRushEnabled;
}

/**
 * Resolves the active shipping rate for a cart. Prefers the live `shippingMethodDetails`
 * (set by the server when the user picks a rate); falls back to the rate list keyed by
 * identifier (the server can null details after a rush update — see failures.md).
 */
export function getSelectedShippingRate(cart: CartOutputDto | null | undefined): ShippingRateOutputDto | undefined {
  if (!cart) return undefined;
  const shippingInfo = cart.shippingInfo;
  return (
    shippingInfo?.shippingMethodDetails ??
    cart.shippingRates?.rates?.find(rate => rate.identifier === shippingInfo?.shippingMethod)
  );
}

export function formatExpectedTransitTime(expectedTransitTime: string | undefined, ground: boolean): string {
  if (!expectedTransitTime) return "";

  const daysNumeric = Number(expectedTransitTime);
  const daysRange = ground ? `${daysNumeric} to ${daysNumeric + 2}` : expectedTransitTime;
  const pluralizedDays = daysNumeric === 1 && !ground ? "day" : "days";

  return `${daysRange} ${pluralizedDays} in transit`;
}
